/* eslint-disable import/prefer-default-export */
import React, { ReactElement } from 'react';
import { PickerItemHandler } from '../editor/fields/helpers/editor-fields-helper';
import { ParentRecordState } from '../record-editor';
import { LinkedRecord } from '../shared/material_components/linked-cell';
import IssuePickerItem from './issue-picker-item';

const ALLOW_MULTILPE_SELECTION = false;

export const issuePickerItemHandler = (): PickerItemHandler => ({
  view: (record: Record<string, any>): ReactElement => (<IssuePickerItem issue={record} />),
  // @ts-ignore
  selectionHandler: (
    records: Record<string, any>[],
    selectedTaskIDs: any[],
    parentRecordState: ParentRecordState,
  ) => {
    const issueRecordSelected = records
      .find((record: Record<string, any>) => record.id
        === selectedTaskIDs[selectedTaskIDs.length - 1].recordId);
    return {
      selectedTaskIDs,
      newParentRecordState: {
        ...parentRecordState,
        newParentRecord: issueRecordSelected || {} as LinkedRecord,
        allowMultiple: ALLOW_MULTILPE_SELECTION,
      },
    };
  },
  recordLinkedTitle: 'Linked Issue',
  selectorTitle: 'Select Issue',
  allowMultiple: ALLOW_MULTILPE_SELECTION,
});
